<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="CBOs"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "cbosTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "cbo_id",
        "cbo_nome",
        "cbo_nome_abreviado",
        "cbo_codigo_sus",
        "status",
        "actions",
      ],
      tableData: [
        "cbo_id",
        "cbo_nome",
        "cbo_nome_abreviado",
        "cbo_codigo_sus",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "cbo_id",
          "cbo_nome",
          "cbo_nome_abreviado",
          "cbo_codigo_sus",
          "status",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          cbo_id: "ID",
          cbo_nome: "Nome do CBO",
          cbo_nome_abreviado: "Nome Abreviado do CBO",
          cbo_codigo_sus: "Código do SUS",
          status: "Status",
          actions: "Ações",
        },
        sortable: [
          "cbo_id",
          "cbo_nome",
          "cbo_nome_abreviado",
          "cbo_codigo_sus",
          "status",
        ],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "cbos",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        cbo_id: "cbo_id",
        cbo_nome: "cbo_nome",
        cbo_nome_abreviado: "cbo_nome_abreviado",
        cbo_codigo_sus: "cbo_codigo_sus",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>